exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control-next[data-v-dbcac4a4],.carousel-control-prev[data-v-dbcac4a4]{filter:invert(100%)}", ""]);

// exports
